import React from 'react';
import { Grid, Card, CardContent, Box, Typography } from '@mui/material';
import { People, School, Payment, Badge as BadgeIcon } from '@mui/icons-material';

const AdminStats = ({ stats, onStatClick }) => {
  const statItems = [
    {
      icon: People,
      value: stats.totalUsers,
      label: 'Utenti',
      color: 'primary.main',
      tabIndex: 0, // Utenti tab
    },
    {
      icon: BadgeIcon,
      value: stats.totalMembers,
      label: 'Tesserati',
      color: 'success.main',
      tabIndex: 1, // Tesserati tab
    },
    {
      icon: School,
      value: stats.totalCourses,
      label: 'Corsi',
      color: 'secondary.main',
      tabIndex: 3, // Corsi tab
    },
    {
      icon: Payment,
      value: stats.totalPayments,
      label: 'Pagamenti',
      color: 'warning.main',
      tabIndex: 4, // Pagamenti Corsi tab
    },
  ];

  const handleStatClick = (tabIndex) => {
    if (onStatClick) {
      onStatClick(null, tabIndex);
    }
  };

  return (
    <Grid container spacing={{ xs: 1 }} width={{ xs: '100%', sm: '80%' }}>
      {statItems.map((item, index) => (
        <Grid key={index} sx={{ display: 'flex', justifyContent: 'center' }} size={{ xs: 6, sm: 6, md: 3 }}>
          <Card
            onClick={() => handleStatClick(item.tabIndex)}
            sx={{
              height: '100%',
              minWidth: { xs: '100%', sm: 200, md: 260 },
              maxWidth: { xs: '100%', sm: 200, md: 260 },
              width: '100%',
              boxShadow: 3,
              borderRadius: 3,
              p: { xs: 1, sm: 1.5, md: 2 },
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: 6,
              },
            }}
          >
            <CardContent
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                py: { xs: 1.5, sm: 2, md: 3 },
                px: { xs: 0.5, sm: 1, md: 2 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
                <item.icon
                  sx={{
                    fontSize: { xs: 32, sm: 40, md: 48 },
                    color: item.color,
                    mr: { xs: 1.5, sm: 2, md: 3 },
                  }}
                />
                <Box>
                  <Typography
                    variant='h3'
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: '1.5rem', sm: '2rem', md: '3rem' },
                    }}
                  >
                    {item.value}
                  </Typography>
                  <Typography
                    variant='body1'
                    color='text.secondary'
                    sx={{
                      fontSize: { xs: '0.75rem', sm: '1rem', md: '1.125rem' },
                    }}
                  >
                    {item.label}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default AdminStats;
